import { LineChart, palette, SimpleLoader, Typography } from "@dev/ee-components";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import React, { useContext, useEffect, useState } from "react";
import useMobile from "@/services/hooks/useMobile";
import { MobileDateFilter } from "@/components/Contacts/Overview/MobileDateRange";
import { DateRangeSelect } from "@/components/Contacts/Overview/DateRange";
import { useContactsGrowthData } from "@/services/hooks/useContactsGrowthData";
import { ContactGetGrowthStart } from "@/store/contacts/actions";
import { ChartBox, WidgetSelect } from "./styles";
import { WidgetPropsContext } from "../Widget";
import { WidgetContent, WidgetTitle } from "../Widget/styles";

export const ContactsGrowthWidgetContent = () => {
    const dispatch = useDispatch();
    const [contactsGrowthFrom, setContactsGrowthFrom] = useState(dayjs().startOf('day').utc().subtract(6, 'day').format('YYYY-MM-DDTHH:mm:ss'));
    const [contactsGrowthTo, setContactsGrowthTo] = useState(dayjs().utc().endOf('day').format('YYYY-MM-DDTHH:mm:ss'));
    const isMobile = useMobile();

    const { title } = useContext(WidgetPropsContext);
    const { formattedData, isGraphLoading, needExpandedYAxis} = useContactsGrowthData(contactsGrowthFrom);
    useEffect(() => {
        dispatch(ContactGetGrowthStart(contactsGrowthFrom, contactsGrowthTo, true));
    }, [contactsGrowthFrom, contactsGrowthTo]); 

    const content = (
        <ChartBox>
            <LineChart
                isEmpty={formattedData?.length === 0}
                data={formattedData}
                xAxisGroupName="Day"
                lineConfig={[
                    {
                        dataKey: 'Contacts',
                        color: palette.indigo[6],
                    },
                ]}
                fullHeight
                fullWidth
                showTooltip
                isLoading={isGraphLoading}
                showLegend={false}
                showGrid
                startFromZero={false}
                yAllowDecimals={false}
                xMinTickGap={15}
                XAxisProps={{
                    interval: 'preserveEnd',
                }}
                YAxisProps={{
                    width: needExpandedYAxis ? 85 : 60,
                }}
            />
        </ChartBox>
    );

    return (
        <>
            <WidgetTitle $isSelectVisible>
                <Typography variant='h2'>
                    {title}
                </Typography>
                <WidgetSelect>
                    {isMobile ? (
                        <MobileDateFilter contactsGrowth={true} setContactsGrowthFrom={setContactsGrowthFrom} contactsGrowthFrom={contactsGrowthFrom} contactsGrowthTo={contactsGrowthTo} setContactsGrowthTo={setContactsGrowthTo} isUrlUpdateDisabled />
                    ) : (
                        <DateRangeSelect contactsGrowthFrom={contactsGrowthFrom} contactsGrowthTo={contactsGrowthTo} setContactsGrowthFrom={setContactsGrowthFrom} setContactsGrowthTo={setContactsGrowthTo} isUrlUpdateDisabled />
                    )}
                </WidgetSelect>
            </WidgetTitle>
            <WidgetContent isContactsGrowth>
                {!isGraphLoading && content}
                {isGraphLoading && <SimpleLoader />}
            </WidgetContent>
        </>
    );
}


